import React from 'react';
import numeral from 'numeral';

export function WidgetAmount ({ color, amount, currency, format = numeral.defaultDecimalFormat }) {
    return (<span
        style={{ color: color || 'inherit' }}
    >{currency}{numeral(amount).format(format)}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetAmount.displayName = 'WidgetAmount';
}
